<template>
  <div class="lista-container">
    <div
      class="header-lista d-flex"
      style="padding-bottom: 0px;"
    >
      <h5><strong style="margin-left: -0.9rem;">{{ titulo }} ({{ propostas.length > 0 ? total : 0 }})</strong></h5>
    </div>
    <div
      class="header-lista d-flex"
      style="padding-top: 0px;"
    >
      <h5><strong style="margin-left: -0.9rem;">{{ propostas.length > 0 ? valorTotal : 0 | converteValor }}</strong></h5></div>
    <div
      class="lista-conteudo"
      @scroll="onScroll"
    >
      <div
        :class="{ 'capa-lista': total == 0 }"
        :style="`background: ${ color }; height: 15px; border-radius: 3px;`"
      />
      <div
        v-for="(proposta) in propostas"
        :key="proposta.id"
        :class="[{'desabilitar-click': !acessoPropostaCartao()}]"
      >
        <router-link
          :id="proposta.id"
          :to="{name:'cadastro-proposta', params: {id: proposta.id}}"
          append
          tag="div"
        >
          <cartao-proposta
            :ref="`Proposta${proposta.id}`"
            :value="proposta"
          />
        </router-link>
      </div>
      <div
        v-if="loadingPropostas && existeProposta"
        class="text-center text-primary"
      >
        <font-awesome-icon
          :icon="['fas', 'spinner']"
          spin
          size="lg"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.lista-container {
  background-color: #ebecf0;
  max-height: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  white-space: normal;

  .header-lista {
    font-weight: bold;
    border: none;
    padding: 0.875rem 1.5rem;
    margin-bottom: 0;

    & > h5 {
      margin: 0;
    }
  }

  .lista-conteudo {
    flex: 1 1 auto;
    margin-bottom: 0;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 4px;
    padding: 0 4px;
    z-index: 1;
    min-height: 0;

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
      }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bfbfbf;
    }
  }
}

.capa-lista {
  margin-bottom: 8px;
}

.desabilitar-click {
  pointer-events: none;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions, mapGetters } from 'vuex'
import { acessoPropostaCartao } from '@/auth/utils'
import api from '@/app-modulo/comercial/proposta/shared/services/api'

/* eslint-disable no-underscore-dangle */
export default {
  name: 'ListaCartao',
  components: {
    CartaoProposta: () => import('@/app-modulo/comercial/proposta/shared/components/cartao-proposta/CartaoProposta.vue'),
    FontAwesomeIcon,
  },
  props: {
    titulo: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: '',
    },
    coluna: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    valorTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      value_: this.value,
      acessoPropostaCartao,
      page: 1,
      loadingPropostas: false,
      existeProposta: false,
    }
  },
  value(value) {
    this.value_ = value
  },
  computed: {
    ...mapGetters('listas', ['filtro']),
    propostas: {
      get() {
        return this.value_
      },
      set(value) {
        this.value_ = value
      },
    },
  },
  methods: {
    ...mapActions('listas', ['adicionarNovasPropostas']),
    onScroll(e) {
      if (!this.loadingPropostas) {
        const { scrollTop, offsetHeight, scrollHeight } = e.target
        if ((scrollTop + offsetHeight) >= scrollHeight) {
          this.loadingPropostas = true
          this.page += 1
          this.filtro.page = this.page
          api.getDadosColunas(this.coluna, this.filtro)
            .then(response => {
              this.existeProposta = response.data.length > 0
              this.adicionarNovasPropostas({ coluna: this.coluna, propostas: response.data })
            })
            .catch(err => {
              this.$erro(err.response.data.message || err.message)
            })
            .finally(() => {
              this.loadingPropostas = false
            })
        }
      }
    },
  },
}
</script>
